export const logo = [
    '685 116',
    `<svg width="685" height="116" viewBox="0 0 685 116" xmlns="http://www.w3.org/2000/svg">
        <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" font-family="Arial, sans-serif" font-size="80" fill="white">
            Utilisation
        </text>
    </svg>`
];
